import React, { useCallback, useEffect, useState } from 'react';
import useFetch from '../../hooks/useFetch';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import logo from '../../assets/logo.png';
import "../../styles/MyProfile.css";
import { faBriefcaseClock } from '@fortawesome/free-solid-svg-icons';
import QRCode from 'react-qr-code';


const MyDigitalCardBusiness = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();
  const userId = authState.user._id;
  const userCode = authState.user.think5whyscode;

  const [profileData, setProfileData] = useState({
    userId: authState.user._id,
    name: authState.user.name,
    gender: 0,
    dob: '',
    email: authState.user.email,
    mobile: '',
    city: '',
    institution: '',
    socialLinks: '',
    personalPageLink: '',
    think5whysCode: authState.user.think5whyscode,
    image: '',
  });

  const [profileExists, setProfileExists] = useState(false);
  const [profileId, setProfileId] = useState('');
  const [loading, setLoading] = useState(true);
  const [createSuccessMsg, setCreateSuccessMsg] = useState('');
  const [urlToScan, setUrlToScan]=useState('');

  useEffect(() => {
    fetchUserProfile(userId);
  }, [userId]);

  const fetchUserProfile = useCallback(() => {
    const config = {
      url: "/myprofile/byid",
      method: 'post',
      data: { userId: userId },
      headers: { Authorization: authState.token },
    };
    fetchData(config)
      .then(response => {
        if (response && response.status) {
          setProfileExists(true);
          const { profile } = response;
          setProfileId(profile._id);
          setProfileData({
            userId: profile.userId,
            name: profile.name,
            gender: profile.gender,
            dob: profile.dob,
            email: profile.email,
            mobile: profile.mobile,
            city: profile.city,
            institution: profile.institution,
            socialLinks: profile.socialLinks,
            personalPageLink: profile.personalPageLink,
            think5whysCode: profile.think5whysCode,
          });
        } else {
          setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
        }
      })
      .catch(error => {
        console.error("Error getting profile:", error);
        setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
      });
  }, [userId, fetchData, authState.token]);

  const origin = window.location.origin;
  const qrValue = `${origin}/pub/${profileData.think5whysCode}`;

  return (
      <div className="bg-black flex flex-col justify-center items-center p-4 relative">
        <div className="bg-gradient-to-r from-gray-200 to-gray-400 border border-gray-600 rounded-lg shadow-lg w-full p-4">
          <div className="flex justify-center mb-4">
          <img 
              src={
                `/api/downloads/users/profilepic/${profileData.think5whysCode}.png` || 
                `/api/downloads/users/profilepic/noprofilepic.png`
              }
              alt="Profile Pic" 
              className="w-32 h-32 rounded-full border-4 border-yellow-400" 
            />
          </div>
          <h2 className="text-gray-800 font-bold text-2xl mb-2 text-center">{profileData.name}</h2>
          <p className="text-sm text-gray-600 mb-1 text-center">ID#: {profileData.think5whysCode}</p>
          <p className="text-sm text-gray-600 mb-1 text-center">Institution: {profileData.institution}</p>
          <p className="text-sm text-gray-600 mb-1 text-center">Email: {profileData.email}</p>
          <p className="text-sm text-gray-600 mb-1 text-center">Mobile: {profileData.mobile}</p>
          <p className="text-sm text-gray-600 mb-4 text-center">Place: {profileData.city}</p>
          <div className="flex justify-around mb-4">
            <a href={profileData.socialLinks?.facebook} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon className="text-blue-600" icon={faFacebook} size="lg" />
            </a>
            <a href={profileData.socialLinks?.instagram} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon className="text-pink-600" icon={faInstagram} size="lg" />
            </a>
            <a href={profileData.socialLinks?.twitter} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon className="text-blue-400" icon={faTwitter} size="lg" />
            </a>
            <a href={profileData.personalPageLink} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon className="text-blue-700" icon={faLinkedin} size="lg" />
            </a>
            <a href={profileData.personalPageLink} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon className="text-gray-600" icon={faBriefcaseClock} size="lg" />
            </a>
          </div>
          
        <div className="bg-black border-4 border-gray-600 rounded-lg mt-2 p-4 w-full max-w-sm flex flex-col justify-center items-center">
          <QRCode value={qrValue} size={128} className="bg-white p-2 rounded-md shadow-md" />
          <a href={qrValue} target="_blank" rel="noopener noreferrer" className='text-xs flex flex-wrap items-center'>
            {qrValue}
          </a>
        </div>
        <div className="rounded-lg mt-2 p-4 w-full max-w-sm flex flex-col justify-center items-center">
          <p className="text-red-700 text-center text-sm py-2 rounded-md mt-2">
              Powered by <img src={logo} alt="Think5Whys" className="inline-block w-6 h-6 mx-2"/> think5whys.com
          </p>
        </div>
      </div>
    </div>
   );
};

export default MyDigitalCardBusiness;
